export const PROFILE_PASS_PARAM = "profilePass"
export const isProfilePassToken = (value: unknown): value is string =>
  typeof value === "string" && /^[a-f0-9]{64}$/.test(value)
export function extractProfilePass(payload: string): string | null {
  try {
    const url = new URL(payload.trim(), "https://winfacil.local")
    const token = url.searchParams.get(PROFILE_PASS_PARAM)
    return isProfilePassToken(token) ? token : null
  } catch { return null }
}
export function hasProfilePassParam(payload: string) {
  try { return new URL(payload.trim(), "https://winfacil.local").searchParams.has(PROFILE_PASS_PARAM) }
  catch { return false }
}
export function passUrl(token: string) {
  const url = new URL("/", window.location.origin)
  url.searchParams.set(PROFILE_PASS_PARAM, token)
  return url.toString()
}
